import React from "react";
import moment from "moment";
import ImageButton from "../../../components/buttons/ImageButton";
import editOnlyIcon from "../../../assets/images/editOnly.png";
import editOnlyIconFocus from "../../../assets/images/editOnlyFocus.png";
import { getRatioColor } from "../utils/evaluationUtils";

export default function EvaluationRatioButton({ yesCount, noCount, month, year, rowData, onClickCell, entreeDate, sortieDate, idTeam }) {
    const collab = {
        id: rowData.id_collab,
        nom: rowData.nom,
        prenom: rowData.prenom,
        id_team: rowData.id_team,
    };
    const date = moment({ year, month: month - 1, day: 1 }).endOf("month");
    const dateStartMonth = moment({ year, month: month - 1, day: 1 }).startOf("month");
    const ratio = (yesCount + noCount !== 0)
        ? ((yesCount / (yesCount + noCount)) * 100).toFixed(2)
        : "non evaluation";

    return (
        <div className="d-flex justify-content-center">
            <ImageButton
                tooltip={ratio}
                image={editOnlyIcon}
                style={{
                    backgroundColor: getRatioColor(yesCount, noCount),
                    borderRadius: "50%",
                    margin: "auto",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                }}
                imageFocus={editOnlyIconFocus}
                onClick={() => onClickCell(collab, date, entreeDate, sortieDate, idTeam, dateStartMonth)}
                active={!(date.isAfter(moment().endOf("month")))}
                width={25}
                height={35}
                imageStyle={{ padding: "3px", paddingBlock: "6px" }}
            />
        </div>
    );
}
